<template>
  <section>
    <!--工具条-->
    <toolbar
      placeholder="请输入名称"
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <!--列表-->
    <el-table
      :data="tenants"
      v-loading="listLoading"
      highlight-current-row
      style="width: 100%"
      ref="table"
      @select="dialogCheck"
      @row-click="selectCurrentRow"
      class="custom-tbl"
    >
      <el-table-column type="selection" min-width="30"></el-table-column>
      <el-table-column type="index" label="序号" min-width="30"></el-table-column>
      <el-table-column
        prop="name"
        label="社区名称"
        min-width="180" show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="address"
        label="社区地址"
        min-width="200" show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="manager"
        label="负责人"
        min-width="100" show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tel"
        label="联系电话"
        min-width="150" show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="isDisable" label="状态" min-width="80" show-overflow-tooltip sortable>
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.isDisable ? 'danger' : 'success'"
            disable-transitions
          >
            {{ scope.row.isDisable ? "停用" : "正常" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isDisable"
            size="small"
            @click="handleDisable(scope.row)"
            >停用</el-button
          >
          <el-button
            v-if="scope.row.isDisable"
            size="small"
            @click="handleEnable(scope.row)"
            >启用</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageModel.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageModel.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageModel.dataCount"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="100px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="社区名称" prop="name">
              <el-input v-model="editForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社区地址" prop="address">
              <el-input
                v-model="editForm.address"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="负责人" prop="manager">
              <el-input
                v-model="editForm.manager"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="tel">
              <el-input v-model="editForm.tel" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="社区简介" prop="description">
            <el-input
              type="textarea"
              v-model="editForm.description"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="logo上传">
              <ImageFile
                tips="推荐尺寸1:1,大小不超过50KB"
                :value="logoImageList"
                :limiCount="1"
                :limitSize="50"
                @change="logoChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否停用" prop="isDisable">
              <el-switch v-model="editForm.isDisable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="宣传图上传">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="coverImageList"
                :limitCount="1"
                :limitSize="1024"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="100px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="社区名称" prop="name">
              <el-input v-model="addForm.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社区地址" prop="address">
              <el-input
                v-model="addForm.address"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="负责人" prop="manager">
              <el-input
                v-model="addForm.manager"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="tel">
              <el-input v-model="addForm.tel" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="社区简介" prop="description">
            <el-input
              type="textarea"
              v-model="addForm.description"
              auto-complete="off"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="logo上传" prop="logo">
              <ImageFile
                tips="推荐尺寸1:1,大小不超过50KB"
                :value="logoImageList"
                :limiCount="1"
                :limitSize="50"
                @change="logoChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否停用" prop="isDisable" width sortable>
              <el-switch v-model="addForm.isDisable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="封面上传" prop="coverImage">
              <ImageFile
                tips="推荐尺寸16:9,大小不超过1MB"
                :value="coverImageList"
                :limitCount="1"
                :limitSize="1024"
                @change="coverImageChange"
              ></ImageFile>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  queryTenantListPage,
  removeTenant,
  saveTenant,
  disableTenant,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import ImageFile from "../../components/ImageFile";

export default {
  components: { Toolbar, ImageFile },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filter: {
        key: "",
        page: 1,
        pageSize: 10,
      },
      tenants: [],
      pageModel: {
        pageSize: 10,
        dataCount: 0,
        page: 1,
        pageCount: 0,
      },
      listLoading: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [
          { required: true, message: "请输入社区名称", trigger: "blur" },
          {
            min: 2,
            max: 200,
            message: "社区名称长度在2到200个字符",
            trigger: "blur",
          },
        ],
        address: [
          {
            max: 500,
            message: "社区名称长度不能超过500个字符",
            trigger: "blur",
          },
        ],
        manager: [
          { max: 50, message: "负责人长度不能超过50个字符", trigger: "blur" },
        ],
        tel: [
          { max: 50, message: "联系电话长度不能超过50个字符", trigger: "blur" },
        ],
        description: [
          { max: 500, message: "简介长度不能超过500个字符", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        name: "",
        address: "",
        sortNum: 0,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: "请输入社区名称", trigger: "blur" },
          {
            min: 2,
            max: 200,
            message: "社区名称长度在2到200个字符",
            trigger: "blur",
          },
        ],
        address: [
          {
            max: 500,
            message: "社区名称长度不能超过500个字符",
            trigger: "blur",
          },
        ],
        manager: [
          { max: 50, message: "负责人长度不能超过50个字符", trigger: "blur" },
        ],
        tel: [
          { max: 50, message: "联系电话长度不能超过50个字符", trigger: "blur" },
        ],
        description: [
          { max: 500, message: "简介长度不能超过500个字符", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        sortNum: 0,
      },
      logoImageList: [],
      coverImageList: [],
    };
  },
  methods: {
    logoChange() {},
    coverImageChange() {},
    handleSizeChange(val) {
      this.filter.page = 1;
      this.filter.pageSize = val;
      this.handleQuery();
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.handleQuery();
    },
    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.filter.key = item.search;
      this[item.func].apply(this, item);
    },
    formatEnabled: function (row, column) {
      return row.enabled ? "正常" : "停用";
    },
    formatStartTime: function (row, column) {
      return row.StartTime | ("" + row.EndTime) | "";
      //   return !row.StartTime || row.StartTime == ""
      //     ? ""
      //     : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    //获取用户列表
    handleQuery() {
      this.listLoading = true;
      //NProgress.start();
      queryTenantListPage(this.filter).then((res) => {
        if(res.data.isSuccess){
          this.pageModel = res.data.response;
          this.tenants = res.data.response.data;
        }
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //停用
    handleDisable(row) {
      if (!row) return;
      this.$confirm("确认停用该社区吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.id, isDisable: true };
          disableTenant(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.isSuccess) {
              this.$message({
                message: "已停用",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //启用
    handleEnable(row) {
      if (!row) return;
      this.$confirm("确认启用该社区吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: row.id, isDisable: false };
          disableTenant(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.isSuccess) {
              this.$message({
                message: "已启用",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.id };
          removeTenant(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.isSuccess) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      this.coverImageList = [];
      this.logoImageList = [];
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      if (row.coverImage) {
        this.coverImageList.push(row.coverImage);
      }
      if (row.logo) {
        this.logoImageList.push(row.logo);
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        title: "",
        showType: "image",
        showUrl: "",
        destinationUrl: "",
        sortNum: 0,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.editForm));
            let logos = this.logoImageList.filter((s) => s.status == "ready");
            if (logos.length > 0) {
              formData.append("logoImage", logos[0].raw);
            }
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            saveTenant(formData).then((res) => {
              if (res.data.isSuccess) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.logoImageList = [];
                this.coverImageList = [];
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let formData = new FormData();
            formData.append("model", JSON.stringify(this.addForm));
            let logos = this.logoImageList.filter((s) => s.status == "ready");
            if (logos.length > 0) {
              formData.append("logoImage", logos[0].raw);
            }
            let covers = this.coverImageList.filter((s) => s.status == "ready");
            if (covers.length > 0) {
              formData.append("coverImage", covers[0].raw);
            }
            saveTenant(formData).then((res) => {
              if (res.data.isSuccess) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.logoImageList = [];
                this.coverImageList = [];
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.handleQuery();
  }
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.table-row-logo {
  width: 45px;
  height: 45px;
}
</style>
